export default (): boolean => {
  return window.innerWidth <= 769;
};
